import ABCyaPhaser, { Images } from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class LevelDisplay extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} game 
   * @param {*} x 
   * @param {*} y 
   * @param {*} countBy 
   */
  constructor(game, x, y, countBy) {
    super(game, 85, 62);

    this.starSprite = game.add.sprite(0, 0, Images.DEFAULT_ATLAS, 'starBase').setOrigin(.5);

    this.setScale(.35);
    this.add(this.starSprite);

    const text = game.add.bitmapText(this.starSprite.x, this.starSprite.y + 8, 'Nasalization', `${countBy}${ABCyaPhaser.Localization.instance.getLocalizedString('number_plural')}`, 80);
    this.add(text);
    text.setOrigin(.5);
    text.align = 'center';
    text.tint = '0x360b5d';
  }
}


